import React from "react";
import {Box, Card, Image, Heading, Text} from 'rebass'
import {DataList} from '../List'

export default class About extends React.Component {
    render() {
        return (
            <main className="" style={{textAlign: 'left'}}>
                <div className='main_background' style={{
                    backgroundImage: `url(${"/img/main_background.jpg"})`,
                    backgroundSize: 'cover',
                    height: 400
                }}>
                    <div className='main_info'>
                        <div className='top_profile'>
                            <Image
                            src="/img/ueda-ryo.jpg"
                            borderRadius={100}
                            className='profile_image'
                            style={{filter: 'none'}} />
                            <div className='main_name' style={{filter: 'none'}}>Ryo Ueda</div>
                        </div>
                        <div className='main_account' style={{filter: 'none'}}>
                            <a href='https://github.com/ryo12882' style={{color: 'white'}}><i className="fab fa-github fa-2x"></i></a>
                            <a href='https://www.facebook.com/profile.php?id=100009515211120' style={{color: 'white'}}><i className="fab fa-facebook fa-2x"></i></a>
                            <a href='https://twitter.com/ryo12882' style={{color: 'white'}}><i className="fab fa-twitter fa-2x"></i></a>
                            <a href='https://www.linkedin.com/in/ryo-ueda/' style={{color: 'white'}}><i className="fab fa-linkedin fa-2x"></i></a>
                        </div>
                    </div>
                </div>
                <div className='main_profile'>
                    <div className='profile_list about'>
                        <div className='profile_index'>About</div>
                        <div className='profile_content'>
                            プロジェクトマネージャー兼エンジニアリングマネージャー。<br />
                            不老不死になること（死を克服すること）をミッションとして、神経科学や機械学習の理論を勉強しています。<br />
                            <a href='https://wbawakate.jp/member/ueda-ryo/' >全脳アーキテクチャ若手の会メンバー</a><br />
                            <a href='https://note.mu/ryo12882'>Note（未稼働）</a>
                        </div>
                    </div>
                    <div className='profile_list bio'>
                        <div className='profile_index'>Bio</div>
                        <div className='profile_content'>
                            東京理科大学理学部応用物理学科卒業。在学中に脳科学に興味を持ち、脳波計の自作を行う。<br />
                            研究「量子アニーリングを用いた巡回セールスマン問題の解析」が学科優秀発表賞を受賞。<br />
                            アイルランド、エストニアでの海外経験、スタンフォード大学のNeurobiology Labで脳波解析ソフトウェアの開発。<br />
                            その後、国内ベンチャー企業にて、ソフトウェアエンジニアリング、ITサービスのプロジェクトを立ち上げを経験。<br />
                            直近では、ロサンゼルスのスタートアップに創業メンバーとしてジョインし、機械学習技術のリサーチ、技術戦略およびプロジェクトマネージャーに従事中。</div>
                    </div>
                    <div className='profile_list skill'>
                        <div className='profile_index'>Skill</div>
                        <div className='profile_content'>
                            Lang: Python / Kotlin / Go / JavaScript / PHP / Swift<br /><br />
                            Framework / Library: Django / Tensorflow / Keras / PyTorch / Android / Ktor / Gin / Node.js / Loopback.js / React / Laravel<br /><br />
                            Software: Apache / Nginx / MySQL / PostgreSQL / Git / Docker / Kubernetes / Unix / CircleCI / Fabric / Ansible / AWS / GCP / Trello<br /><br />
                            Cert: Statistical Society Certificate(JSSC) / System Architect(IPA) / Kaggle Master(aiming)
                        </div>
                    </div>
                    <div className='profile_list like'>
                        <div className='profile_index'>Like</div>
                        <div className='profile_content'>
                            Topic: Neuroscience / Quantum Annealing / Deep Generative Neural Network / Reinforcement Learning<br />
                            Other: Basketball(OKC), <a href='https://docs.google.com/spreadsheets/d/1kxyHQrf_CameP1iMVYsmMq6YwS2tzsRxDjvu2rEWuwE/edit?usp=sharing'>Books</a>
                        </div>
                    </div>
                    <div className='profile_list contact'>
                        <div className='profile_index'>Contact</div>
                        <div className='profile_content'>
                            FB Messenger、TwitterのDMまたは、r.y.p0610[at]gmail.comまでお願い致します。<br /><br />
                            Please contact me by Facebook Messenger, Direct Message of Twitter and email: r.y.p0610[at]gmail.com if you need.
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}
